import Icon from 'vue-awesome/components/Icon'

Icon.register({
  playlist_add_check_rounded: {
    paths: [
      {
        d: 'M13 10H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zM3 16h6c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1zm19.21-3.79l.09.09c.39.39.39 1.02 0 1.41l-5.58 5.59a.996.996 0 01-1.41 0l-3.09-3.09a.996.996 0 010-1.41l.09-.09a.996.996 0 011.41 0l2.3 2.3 4.78-4.79c.38-.4 1.02-.4 1.41-.01z'
      }
    ],
    width: '24',
    height: '24'
  }
})
